import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { ClipPath, Defs, G, LinearGradient, Path, Rect, Stop } from 'react-native-svg';

const ExcelIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    const { width = 38, height = 39 } = props;
    return (
      <View style={props.containerStyle}>
        <Svg width={width} height={height} viewBox="0 0 38 39" fill="none" {...props}>
          <G clipPath="url(#clip0_3111_3521)">
            <Path
              d="M23.5401 18.6159L8.91211 15.9648V35.5541C8.91211 36.4485 9.61814 37.1743 10.4897 37.1743H35.7306C36.6014 37.1743 37.3082 36.4492 37.3082 35.5541V28.3371L23.5401 18.6159Z"
              fill="#185C37"
            />
            <Path
              d="M23.5401 1.82812H10.4897C9.61887 1.82812 8.91211 2.55324 8.91211 3.44832V10.6654L23.5401 19.5026L31.2841 22.1537L37.3074 19.5026V10.6654L23.5401 1.82812Z"
              fill="#21A366"
            />
            <Path d="M8.91211 10.6641H23.5401V19.5013H8.91211V10.6641Z" fill="#107C41" />
            <Path
              opacity="0.1"
              d="M19.3812 8.89844H8.91211V30.9911H19.3812C20.2513 30.9882 20.9559 30.2645 20.9588 29.3709V10.5179C20.9559 9.6243 20.2513 8.90141 19.3812 8.89844Z"
              fill="black"
            />
            <Path
              opacity="0.2"
              d="M18.5213 9.78125H8.91211V31.8747H18.5213C19.3913 31.8717 20.0959 31.1481 20.0988 30.2545V11.4014C20.0952 10.5079 19.3906 9.78422 18.5213 9.78125Z"
              fill="black"
            />
            <Path
              opacity="0.2"
              d="M18.5213 9.78125H8.91211V30.1068H18.5213C19.3913 30.1038 20.0959 29.3802 20.0988 28.4866V11.4014C20.0952 10.5079 19.3906 9.78422 18.5213 9.78125Z"
              fill="black"
            />
            <Path
              opacity="0.2"
              d="M17.6606 9.78125H8.91211V30.1068H17.6606C18.5307 30.1038 19.2353 29.3802 19.2381 28.4866V11.4014C19.2345 10.5079 18.5307 9.78422 17.6606 9.78125Z"
              fill="black"
            />
            <Path
              d="M1.8842 9.78125H17.6598C18.5306 9.78125 19.2373 10.5064 19.2373 11.4014V27.6034C19.2373 28.4977 18.5313 29.2236 17.6598 29.2236H1.8842C1.01268 29.2236 0.306641 28.4985 0.306641 27.6034V11.4014C0.306641 10.5064 1.01268 9.78125 1.8842 9.78125Z"
              fill="url(#paint0_linear_3111_3521)"
            />
            <Path
              d="M5.19141 24.7653L8.50912 19.4854L5.46891 14.2344H7.91438L9.57359 17.5928C9.7268 17.9119 9.83158 18.1487 9.88867 18.3053H9.91035C10.0195 18.0507 10.1344 17.8036 10.2543 17.5638L12.0277 14.2366H14.273L11.1555 19.4564L14.3518 24.766H11.9627L10.0462 21.0803C9.95588 20.9237 9.87928 20.7589 9.81713 20.5882H9.78895C9.73258 20.7552 9.65814 20.9155 9.56709 21.0655L7.59424 24.7668L5.19141 24.7653Z"
              fill="white"
            />
            <Path
              d="M35.7288 1.82812H23.5391V10.6654H37.3064V3.44832C37.3064 2.55324 36.6004 1.82812 35.7288 1.82812Z"
              fill="#33C481"
            />
            <Path d="M23.5391 19.5H37.3064V28.3372H23.5391V19.5Z" fill="#107C41" />
          </G>
          <Defs>
            <LinearGradient
              id="paint0_linear_3111_3521"
              x1="3.5952"
              y1="8.51576"
              x2="16.449"
              y2="30.1922"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#18884F" />
              <Stop offset="0.5" stopColor="#117E43" />
              <Stop offset="1" stopColor="#0B6631" />
            </LinearGradient>
            <ClipPath id="clip0_3111_3521">
              <Rect width="37" height="38" fill="white" transform="translate(0.306641 0.5)" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { ExcelIcon };
